import { useMemo } from 'react';
import { hasGate } from '../utils/auth';
export const useIsUngatedFor = gateName => useMemo(() => hasGate(gateName), [gateName]);